/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_Rows_Fit_RightInputs */

const en_directory_comparison_product_hunt_rows_fit_right = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Fit_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You want a focused launch-day campaign`)
};

const zh_directory_comparison_product_hunt_rows_fit_right = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Fit_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你需要聚焦发布日的推广活动`)
};

/**
* | output |
* | --- |
* | "You want a focused launch-day campaign" |
*
* @param {Directory_Comparison_Product_Hunt_Rows_Fit_RightInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_rows_fit_right = /** @type {((inputs?: Directory_Comparison_Product_Hunt_Rows_Fit_RightInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_Rows_Fit_RightInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_rows_fit_right(inputs)
	return zh_directory_comparison_product_hunt_rows_fit_right(inputs)
});
export { directory_comparison_product_hunt_rows_fit_right as "directory.comparison.product_hunt.rows.fit.right" }